import { ADFEntity } from '~/domain/ADFEntity';
import { IJiraField } from '~/domain/IJiraField';
import { JiraIssueFields } from '~/domain/IJiraIssue';
import { IJiraSelection } from '~/domain/IJiraSelection';
import { IJiraValue } from '~/domain/IJiraValue';

/**
 * Get a string property of the specified field from the jira values of an issue
 * @param fields
 * @param field
 */
export const mapFieldValue = (fields: JiraIssueFields, field?: IJiraField): string => {
  if (!field) {
    return '';
  }

  const fieldValue = fields[field.key];

  // if value for the specified field exists
  if (fieldValue) {

    // if field is a selection, value will be of the form { id: string, value: string }
    if ((fieldValue as IJiraValue).value) {
      return (fieldValue as IJiraValue).value.toString();
    }

    // treat value as a string
    return fieldValue.toString();
  }
  return '';
}

export const mapFieldSelection = (fields: JiraIssueFields, field?: IJiraField): IJiraSelection | undefined => {
  if (field) {
    const fieldValue = fields[field.key];
    return fieldValue as IJiraSelection;
  }
}

export const findNode = (body: ADFEntity | undefined, check: (node: ADFEntity) => boolean): ADFEntity | undefined => {
  if (!body) {
    return undefined;
  }
  const { content = [] } = body;
  const node = content.find(x => x && check(x));
  if (node) {
    return node;
  }
  for (let i = 0; i < content.length; i++) {
    const childNode = content[i];
    if (childNode) {
      const node = findNode(childNode, check);
      if (node) {
        return node;
      }
    }
  }
}
export const findNodes = (body: ADFEntity | undefined, check: (node: ADFEntity) => boolean): ADFEntity[] => {
  if (!body) {
    return [];
  }
  const { content = [] } = body;
  const nodes = content.filter(x => x && check(x));
  for (let i = 0; i < content.length; i++) {
    const childNode = content[i];
    if (childNode) {
      const childNodes = findNodes(childNode, check);
      nodes.push(...childNodes);
    }
  }
  return nodes as ADFEntity[];
}
